module.exports = __webpack_public_path__ + "img/close.286b998a.svg";